  document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.querySelector('.toggle-collection-description');
    const description = document.querySelector('.collection-description');

    if (!toggleBtn || !description) return;

    const lineHeight = 20; // in px, adjust based on your CSS
    const maxLines = 25;
    const lineLimitPx = lineHeight * maxLines;

    // Wait for layout to fully render
    requestAnimationFrame(() => {
      const actualHeight = description.scrollHeight;

      if (actualHeight > lineLimitPx) {
        toggleBtn.style.display = 'inline-block';
        description.classList.add('collapsed');
      } else {
        toggleBtn.style.display = 'none';
      }

      toggleBtn.addEventListener('click', function () {
        const isExpanded = description.classList.toggle('expanded');
        description.classList.toggle('collapsed', !isExpanded);
        toggleBtn.textContent = isExpanded ? 'Read less' : 'Read more';
      });
    });
  });